<template>
  <div class="top-bar">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <!-- If page-specific (Directory Landing Page) or homepage topBarInfo has content, render it -->
          <div v-if="!isEmpty(topBarHtml)" class="top-bar-html case-info">
            <SmartLinkElement :codename="contentTypes.configuration_file.elements.top_bar_info.codename">   
                <span v-for="(phrase, index) in topBarPhrases" :key="index" v-html="phrase"></span>
            </SmartLinkElement>
          </div>
          <!-- Fallback: default topbar information -->
          <div v-else class="case-info">
            <SmartLinkElement :codename="contentTypes.configuration_file.elements.case_name.codename"
              :item-id="siteStore.siteConfig.system.id">
              <span class="case-name">{{ siteStore.siteConfig.elements.caseName.value }}</span>
            </SmartLinkElement>
            <SmartLinkElement v-if="siteStore.siteConfig.elements.administrationName.value"
              :codename="contentTypes.configuration_file.elements.administration_name.codename"
              :item-id="siteStore.siteConfig.system.id">
              <span class="admin-name">{{
                siteStore.siteConfig.elements.administrationName.value
              }}</span>
            </SmartLinkElement>
            <SmartLinkElement :codename="contentTypes.configuration_file.elements.case_number.codename"
              :item-id="siteStore.siteConfig.system.id">
              <span class="case-number">{{ siteStore.siteConfig.elements.caseNumber.value }}</span>
            </SmartLinkElement>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { DirectoryLandingPageModel } from '~/models'
import { contentTypes } from '~/models'

const siteStore = useSiteStore()
const pageStore = usePageStore()

const { homepageItem } = useNavigationGroup()

// Detect if current page is a Directory Landing Page
const isDirectoryLandingPage = computed(() => pageStore.page?.system?.type === contentTypes.directory_landing_page.codename)

// Extract HTML from DirectoryLandingPage.topBarInfo when available
const directoryTopBarHtml = computed<string | ''>(() => {
  if (!isDirectoryLandingPage.value) return ''
  const page = pageStore.page as DirectoryLandingPageModel | null
  const html = (page as any)?.elements?.topBarInfo?.value as string | undefined
  return html && html.trim() ? html : ''
})

// Prefer Directory Landing Page top bar info; fallback to Homepage top bar info
const homePageHtml = computed<string | ''>(() => {
  if (directoryTopBarHtml.value) return directoryTopBarHtml.value
  const html = (homepageItem.value?.elements?.topBarInfo as any)?.value as string | undefined
  return html && html.trim() ? html : ''
})

// Prefer Homepage top bar info; fallback to configuration file top bar info
const topBarHtml = computed<string | ''>(() => {
  if (homePageHtml.value) return homePageHtml.value
  const html = (siteStore.siteConfig.elements.topBarInfo as any)?.value as string | undefined
  return html && html.trim() ? html : ''
})

// Split by | and trim whitespace
const topBarPhrases = computed(() => removePTags(topBarHtml.value).split('|').map(s => s.trim()))

</script>